import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ExamFolderService } from 'src/app/services/exam-folder.service';  
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-exam-folders',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './exam-folders.component.html',
  styleUrls: ['./exam-folders.component.css'],
})
export class ExamFoldersComponent {
  constructor(private examFolderService: ExamFolderService, public translationService: TranslationService) {}

  addFolderModal: boolean = false;
  viewFolderModal: boolean = false;
  editFolderModal: boolean = false;
  deleteFolderModal: boolean = false;
  deleteConfirmationModal: boolean = false; 
  selectedFolder: any = null;
  showErrorMessage: boolean = false; 

  folderName: string = '';
  editCourseName: string = '';
  folderDTO: any = {
    ID: 0,
    CourseName: '',
    CourseUnitsCount: 0,
    UnitsDetails: [{ UnitId: 0, UnitName: '' }]
  };

  allExamFolders: any[] = [];

  UnitDTO: any = {
    UnitId: 0,
    UnitName: ''
  };
  
  FolderDTO: any = {
    ID: 0,
    CourseName: '',
    CourseUnitsCount: 0,
    UnitsDetails: []
  };

  ngOnInit() {
    this.loadFolders();
  }
  
  loadFolders() {
    this.examFolderService.getFolders().subscribe((response) => {
      this.allExamFolders = response.result[0] || [];
      this.allExamFolders.forEach((folder: any) => {
        if (folder?.ID && folder["Course Name"] && folder["Course Units Count"]) {
          let folderDTO = {
            ...this.FolderDTO,
            ID: folder["ID"],
            CourseName: folder["Course Name"],
            CourseUnitsCount: folder["Course Units Count"],
            UnitsDetails: [],
          };
  
          if (folder.UnitsDetails) {
            JSON.parse(folder.UnitsDetails).forEach((unit: any) => {
              folderDTO.UnitsDetails.push({
                ...this.UnitDTO,
                UnitId: unit.UnitId,
                UnitName: unit["Unit Name"],
              });
            });
          }
        }
      });
    });
  }

  addFolder() {
    this.addFolderModal = true;
    this.folderName = '';
    this.folderDTO.UnitsDetails = [{ UnitId: 0, UnitName: '' }];
  }

  addUnit() {
    this.folderDTO.UnitsDetails.push({ UnitId: 0, UnitName: '' });
  }

  removeUnit(index: number) {
    this.folderDTO.UnitsDetails.splice(index, 1);
  }

  submitAddFolder() {
    const courseUnitsString = this.folderDTO.UnitsDetails
      .filter((unit: any) => unit.UnitName.trim() !== '')
      .map((unit: any) => unit.UnitName)
      .join(', ');

    this.examFolderService.addFolder(this.folderName, courseUnitsString).subscribe((response) => {
      this.loadFolders();
      this.closeModal();
    });
  }

  isFormValid(): boolean {
    return (
      this.folderName.trim() !== '' &&
      this.folderDTO.UnitsDetails.every((unit: any) => unit.UnitName.trim() !== '')
    );
  }

  viewFolder(folder: any) {
    this.selectedFolder = folder;
    this.viewFolderModal = true;
    this.UnitDTO = JSON.parse(this.selectedFolder.UnitsDetails); 
  }

  editFolder(folder: any) {
    this.selectedFolder = { ...folder };
    this.editCourseName = folder['Course Name'] || '';
    this.UnitDTO = JSON.parse(folder.UnitsDetails || '[]').map((unit: any) => ({
      UnitId: unit.UnitId ?? 0,
      'Unit Name': unit['Unit Name'] || '',
    }));

    if (this.UnitDTO.length === 0) {
      this.UnitDTO = [{ UnitId: 0, 'Unit Name': '' }];
    }

    this.editFolderModal = true;
  }

  addEditUnit() {
    this.UnitDTO.push({ UnitId: 0, 'Unit Name': '' });
  }

  removeEditUnit(index: number) {
    if (this.UnitDTO.length > 1) {
      this.UnitDTO.splice(index, 1);
    }
  }
  
  submitEditFolder(folder: any) {
    if (!folder || !folder.ID) {
      return;
    }
  
    const courseID = folder.ID;
  
    if (!this.editCourseName || !this.editCourseName.trim()) {
      return;
    }
  
    if (this.UnitDTO.some((unit: any) => !unit['Unit Name'] || !unit['Unit Name'].trim())) {
      return;
    }
  
    const unitNames = this.UnitDTO.map((unit: { UnitId: number; 'Unit Name': string }) => {
      return `${unit.UnitId}-${unit['Unit Name']}`;
    }).join(',');
    

    this.examFolderService.updateFolder(courseID, this.editCourseName, unitNames).subscribe((response) => {
      this.loadFolders();
      this.closeModal();
    });

  }

  isEditFormValid(): boolean {
    return (
      this.editCourseName.trim() !== '' &&
      this.UnitDTO.every((unit: any) => unit['Unit Name'].trim() !== '')
    );
  }
  
  deleteFolder(folder: any) {
    this.selectedFolder = folder;
    this.deleteConfirmationModal = true;
  }

  confirmDelete() {
    if (this.selectedFolder) {
      this.examFolderService.deleteFolder(this.selectedFolder["ID"]).subscribe((response) => {        
        if (response.success === false) {
          this.showMessage();
          this.deleteConfirmationModal = false;
          this.selectedFolder = null;
          return;
        }
  
        this.loadFolders();
        this.deleteConfirmationModal = false;
        this.selectedFolder = null;
      });
    }
  }

  closeModal() {
    this.addFolderModal = false;
    this.editFolderModal = false;
    this.deleteFolderModal = false;
    this.deleteConfirmationModal = false;
    this.viewFolderModal = false;
    this.showErrorMessage = false;
    this.selectedFolder = null;
    this.editCourseName = '';
  }
  
  showMessage() {
    this.showErrorMessage = true;
    setTimeout(() => {
      this.showErrorMessage = false;
    }, 3000);
  }  
}
